import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ImageStore } from "./ImageStore";
export var PickleballS3ImageStore = /*#__PURE__*/function (_ImageStore) {
  _inherits(PickleballS3ImageStore, _ImageStore);
  var _super = _createSuper(PickleballS3ImageStore);
  function PickleballS3ImageStore(config) {
    _classCallCheck(this, PickleballS3ImageStore);
    return _super.call(this, config);
  }
  _createClass(PickleballS3ImageStore, [{
    key: "_getPresignedUrl",
    value: function () {
      var _getPresignedUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, contentType) {
        var psUrl, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("".concat(this._config.uploadUrl), {
                method: "POST",
                body: JSON.stringify({
                  key: key,
                  contentType: contentType
                }),
                headers: {
                  "Content-Type": "application/json",
                  "PB-USER-TOKEN": "".concat(this._config.token)
                }
              });
            case 2:
              psUrl = _context.sent;
              _context.next = 5;
              return psUrl.json();
            case 5:
              result = _context.sent;
              return _context.abrupt("return", result.presignedURL);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _getPresignedUrl(_x, _x2) {
        return _getPresignedUrl2.apply(this, arguments);
      }
      return _getPresignedUrl;
    }()
  }, {
    key: "_upload",
    value: function () {
      var _upload2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        var key, contentType, presignedURL, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              key = "".concat(this._config.bucketPath, "/").concat(Date.now(), "/").concat(file.name).replace(/\s/g, "");
              contentType = file.type;
              _context2.next = 5;
              return this._getPresignedUrl(key, contentType);
            case 5:
              presignedURL = _context2.sent;
              _context2.next = 8;
              return fetch(presignedURL, {
                method: "PUT",
                body: file,
                headers: {
                  "Content-Type": contentType
                }
              });
            case 8:
              response = _context2.sent;
              if (!(response.status === 200)) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return", {
                uploadURL: "https://images.pickleball.com/".concat(key),
                status: 200
              });
            case 13:
              console.log("Something wrong happened and we were not able to process the image.");
              return _context2.abrupt("return", {
                status: 500
              });
            case 15:
              _context2.next = 21;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.log("Could not upload image.");
              return _context2.abrupt("return", {
                status: 500
              });
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 17]]);
      }));
      function _upload(_x3) {
        return _upload2.apply(this, arguments);
      }
      return _upload;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state, token, uploadUrl) {
        var dest, storeResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (token) this._config.token = token;
              if (uploadUrl) this._config.uploadUrl = uploadUrl;
              if (this._config.token) {
                _context3.next = 5;
                break;
              }
              console.error("Missing user token in upload request. Provide it through the store or as props in ImageEditor component.");
              throw new Error("Missing user token in request.");
            case 5:
              if (this._config.uploadUrl) {
                _context3.next = 8;
                break;
              }
              console.error("Missing upload URL to obtain presigned S3 upload URL. Provide it in store or as prop in ImageEditor component.");
              throw new Error("Missing upload URL in config.");
            case 8:
              dest = state.dest;
              _context3.next = 11;
              return this._upload(dest);
            case 11:
              storeResponse = _context3.sent;
              return _context3.abrupt("return", _extends({}, state, {
                store: storeResponse
              }));
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function init(_x4, _x5, _x6) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this._config;
    }
  }]);
  return PickleballS3ImageStore;
}(ImageStore);
export var createS3ImageStore = function createS3ImageStore(config) {
  return new PickleballS3ImageStore(config);
};